import { ApiUrls } from '@api/apiUrls';
import { fetchApi } from '@api/fetchApi';
import {
  IApiTradingAccountCardActions,
  IApiTradingAccountCardCategory,
  IApiTradingAccountCardInfo,
} from '@api/interfaces/data-contracts';

export const apiTradingAccountCardUser = {
  getActions: async (id: number) => {
    return await fetchApi.get<IApiTradingAccountCardActions>(ApiUrls.tradingAccountCardUser.getActions, {
      params: { id },
    });
  },
  getCategories: async () => {
    return await fetchApi.get<IApiTradingAccountCardCategory[]>(ApiUrls.tradingAccountCardUser.getCategories);
  },
  getSelfTradingAccounts: async () => {
    return await fetchApi.get<IApiTradingAccountCardInfo[]>(ApiUrls.tradingAccountCardUser.getSelfTradingAccounts);
  },
};
